<template>
    <div class="flex items-center gap-4">
        <div :class="ringSizeClasses">
            <new-progress-ring
                :percent-filled="scorePercent"
                :height="compact ? 'auto' : '144px'"
            >
                <div class="flex flex-col items-center justify-center">
                    <div class="text-[16px]">Readiness</div>
                    <div class="text-[20px]">{{ scorePercent }}/100</div>
                </div>
            </new-progress-ring>
        </div>
        <div class="text-[16px] text-gray-625" v-if="!compact">
            <div class="flex flex-col gap-1 tracking-tight">
                <div class="flex items-center gap-1 lg:gap-4">
                    <div class="w-[20px] flex-none">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="20"
                                height="20"
                                rx="4"
                                fill="#E25941"
                            />
                        </svg>
                    </div>
                    <div class="">Not&nbsp;Ready&nbsp;(0-70)</div>
                </div>
                <div class="flex items-center gap-1 lg:gap-4">
                    <div class="w-[20px] flex-none">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="20"
                                height="20"
                                rx="4"
                                fill="#F4AB3E"
                            />
                        </svg>
                    </div>
                    <div class="">Almost&nbsp;Ready&nbsp;(71-89)</div>
                </div>
                <div class="flex items-center gap-1 lg:gap-4">
                    <div class="w-[20px] flex-none">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="20"
                                height="20"
                                rx="4"
                                fill="#1F9294"
                            />
                        </svg>
                    </div>
                    <div class="">Ready&nbsp;(90-100)</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NewProgressRing from "@/Components/NewProgressRing.vue";

export default {
    name: "StudentReadinessScoreWidget",
    components: { NewProgressRing },
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
        ringSizeClasses: {
            type: String,
            default: "w-40 h-40 md:w-40 md:h-40",
        },
        scorePercent: {
            type: Number,
            default: 0,
        },
    },
};
</script>
